import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/public/assets/images/hero/SocBanner.webp");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/src/components/container/container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["SectionHeading"] */ "/var/www/SOC/src/components/section-heading/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/var/www/SOC/src/sections/contact/v1/form/index.tsx");
